import React from "react";
import { Button, Space } from "antd";

const sizeOptions = [10, 20, 50, 100];

/**
 * Ant Design Table pagination with compact button group for page size.
 *
 * Usage:
 *   const [pageSize, setPageSize] = useState(10);
 *   <Table pagination={makePagination(pageSize, setPageSize)} />
 */
export function makePagination(pageSize, setPageSize, extra = {}) {
  return {
    pageSize,
    showSizeChanger: false,
    showTotal: (total) => (
      <Space size={4}>
        <span>{total} items</span>
        <Space.Compact size="small">
          {sizeOptions.map((size) => (
            <Button
              key={size}
              size="small"
              type={pageSize === size ? "primary" : "default"}
              onClick={() => setPageSize(size)}
              style={{ padding: "0 6px", fontSize: 12 }}
            >
              {size}
            </Button>
          ))}
        </Space.Compact>
      </Space>
    ),
    ...extra,
  };
}
